export default __webpack_public_path__ + "static/12-7b60aa805a3050b2ceaf80badc85a2ef.png";